// Routes owned by the Invoice module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const invoicePaths = {
    invoices: '/invoices',
    invoiceDetail: '/invoices/:id',
} as const
